// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import constants from "@store/constants";
import applyDraftParameter from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/ApplyDraftParameter";
import cancelDraftParameterChanges from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/CancelDraftParameterChanges";
import clearDraftParameter from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/ClearDraftParameter";
import updateParameter from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/UpdateParameter";
import {
    useShipmentHistoryDataView,
    useShipmentHistoryState,
} from "@store/Framework/Store/Greif/Pages/ShipmentHistory/ShipmentHistoryHooks";
import FilterDrawerAndButton from "@store/Library/Components/FilterDrawerAndButton";
import ShipmentHistoryFilterFieldItemNumber from "@store/Library/Components/ShipmentHistory/ShipmentHistoryFilterFieldItemNumber";
import ShipmentHistoryFilterFieldLocation from "@store/Library/Components/ShipmentHistory/ShipmentHistoryFilterFieldLocation";
import ShipmentHistoryFilterFieldOrderDates from "@store/Library/Components/ShipmentHistory/ShipmentHistoryFilterFieldOrderDates";
import ShipmentHistoryFilterFieldOrderNumber from "@store/Library/Components/ShipmentHistory/ShipmentHistoryFilterFieldOrderNumber";
import ShipmentHistoryFilterFieldPoNumber from "@store/Library/Components/ShipmentHistory/ShipmentHistoryFilterFieldPoNumber";
import ShipmentHistoryFilterFieldShipTo from "@store/Library/Components/ShipmentHistory/ShipmentHistoryFilterFieldShipTo";
import ShipmentHistoryFilterFieldStatus from "@store/Library/Components/ShipmentHistory/ShipmentHistoryFilterFieldStatus";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import QuickSearchField from "@store/Library/Components/QuickSearchField";
import { quickSearchAndFilterProps, QuickSearchAndFilterProps } from "@store/Themes/common/props/quickSearchAndFilter";
import React, { FC } from "react";

export interface ShipmentHistoryHeaderStyles extends QuickSearchAndFilterProps {
    heading?: HeadingPresentationProps;
}

export const shipmentHistoryHeaderStyles: ShipmentHistoryHeaderStyles = {
    heading: {
        variant: "h1",
    },
    quickSearchWrapper: quickSearchAndFilterProps.quickSearchWrapper,
    quickSearchField: quickSearchAndFilterProps.quickSearchField,
    filterDrawerAndButton: quickSearchAndFilterProps.filterDrawerAndButton,
};

const styles = shipmentHistoryHeaderStyles;

const ShipmentHistoryHeader: FC = () => {
    const dispatch = useAppDispatch();
    const { isLoading } = useShipmentHistoryDataView();
    const { canApplyFilters, canClearFilters, filterCount, parameter } = useShipmentHistoryState();

    const handleSearch = (value: string) => {
        dispatch(updateParameter({ search: value.trim() || undefined }));
    };

    return (
        <>
            <Heading {...styles.heading} usePageTitle={true} />
            <StyledWrapper {...styles.quickSearchWrapper}>
                <QuickSearchField
                    {...styles.quickSearchField}
                    placeholder={translate("Search by PO #, Greif Order # or Item #")}
                    initialValue={parameter.search ?? ""}
                    onSearch={handleSearch}
                />
                <FilterDrawerAndButton
                    {...styles.filterDrawerAndButton}
                    filterCount={filterCount}
                    filterButtonProps={{
                        disabled: isLoading,
                    }}
                    drawerProps={{
                        handleClose: () => dispatch(cancelDraftParameterChanges()),
                        headline: translate("Filter Shipments"),
                    }}
                    applyButtonProps={{
                        disabled: !canApplyFilters,
                        onClick: () => dispatch(applyDraftParameter()),
                    }}
                    clearButtonProps={{
                        disabled: !canClearFilters,
                        onClick: () => dispatch(clearDraftParameter()),
                    }}
                >
                    <ShipmentHistoryFilterFieldShipTo />
                    <ShipmentHistoryFilterFieldPoNumber />
                    <ShipmentHistoryFilterFieldOrderNumber />
                    <ShipmentHistoryFilterFieldItemNumber />
                    <ShipmentHistoryFilterFieldLocation />
                    <ShipmentHistoryFilterFieldStatus />
                    <ShipmentHistoryFilterFieldOrderDates />
                </FilterDrawerAndButton>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: ShipmentHistoryHeader,
    definition: {
        displayName: "Header (V2)",
        group: constants.widgetGroup.shipmentHistory,
        allowedContexts: [constants.pageType.shipmentHistory],
        fieldDefinitions: [],
    },
};

export default widgetModule;
